"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouterApi = void 0;
class RouterApi {
    constructor(router, history) {
        this.router = router;
        this.history = history;
        this.block = (prompt) => {
            this.router.block(prompt);
        };
        this.unblock = () => {
            this.router.unblock();
        };
        this.isBlocked = () => {
            return this.router.isBlocked();
        };
        this.goTo = (name, params, query) => {
            this.history.push(this.router.resolvePath(name, params, query));
        };
        this.goBack = () => {
            this.history.goBack();
        };
        this.replace = (name, params, query) => {
            this.history.replace(this.router.resolvePath(name, params, query));
        };
        this.resolvePath = (name, params, query) => {
            return this.router.resolvePath(name, params, query);
        };
        this.resolveAbsolutePath = (name, params, query) => {
            return `${window.location.origin}${this.resolvePath(name, params, query)}`;
        };
        this.resolveRoute = (url) => {
            return this.router.resolveRoute(url);
        };
        this.isActive = (name) => {
            return this.router.getCurrentMatch().isRouteActive(name);
        };
        this.isAllow = (name, params, query) => {
            return this.router.isRouteAllow(name, params, query);
        };
        this.getQuery = () => {
            return this.router.getCurrentMatch().getQuery();
        };
        this.getParams = () => {
            return this.router.getCurrentMatch().getParams();
        };
        this.getName = () => {
            return this.router.getCurrentMatch().getName();
        };
        this.getResourceName = () => {
            return this.router.getCurrentMatch().getResourceName();
        };
        this.match = (matchRecords) => {
            return this.router.getCurrentMatch().match((name) => matchRecords[name]);
        };
    }
}
exports.RouterApi = RouterApi;
//# sourceMappingURL=RouterApi.js.map